export default {
  UPDATE_SIDE_MENU_SHOW: (state, val) => {
    state.sideMenuShow = val
  },
  UPDATE_COLLAPSE: (state, val) => {
    state.collapse = val
  },
  UPDATE_MODULES_MENU_SHOW: (state, val) => {
    state.modulesMenuShow = val
  },
  UPDATE_AUTH: (state, val) => {
    state.auth = val
  },
  UPDATE_AUTH_HAD: (state, val) => {
    state.authHad = val
  },
  UPDATE_ROUTER: (state, val) => {
    state.router = val
  },
  UPDATE_SYS_LIST: (state, val) => {
    state.sysList = val
  },
  UPDATE_UNSER_INFO: (state, val) => {
    state.userInfo = val
  },
  UPDATE_TABLE_QUERY: (state, val) => {
    state.tableQuery = val
  },
  UPDATE_HEADER_SHOW: (state, val) => {
    state.headerShow = val
  },
  UPDATE_KEEP_ALIVE_ROUTES: (state, val) => {
    state.keepAliveRoutes = val
  },
}


// WEBPACK FOOTER //
// ./src/vuex/mutations.js